(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 4812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path, _circle, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function SvgCt(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 452.2 96",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    className: "ct_svg__st0",
    fill: "#222",
    d: "M140.6 30.7c-4.2 0-7.4 1.6-9.7 4.7s-3.4 7.5-3.4 13.1c0 11.7 4.4 17.5 13.2 17.5 3.7 0 8.1-.9 13.4-2.8v9.3c-4.3 1.8-9.1 2.7-14.4 2.7-7.6 0-13.5-2.3-17.5-6.9s-6.1-11.3-6.1-19.9c0-5.5 1-10.2 3-14.3s4.8-7.2 8.6-9.4c3.7-2.2 8.1-3.3 13.1-3.3 5.1 0 10.2 1.2 15.3 3.7l-3.6 9c-2-.9-3.9-1.7-5.9-2.4-2.1-.7-4.1-1-6-1zM187.3 74.6l-2.1-5.4h-.3c-1.8 2.3-3.7 3.9-5.7 4.8-1.9.9-4.5 1.3-7.6 1.3-3.8 0-6.9-1.1-9.1-3.3s-3.3-5.3-3.3-9.4c0-4.3 1.5-7.4 4.5-9.4s7.5-3.1 13.5-3.4l7-.2v-1.8c0-4.1-2.1-6.1-6.2-6.1-3.2 0-7 1-11.3 2.9l-3.6-7.4c4.6-2.4 9.7-3.6 15.3-3.6 5.4 0 9.5 1.2 12.4 3.5s4.3 5.9 4.3 10.7v26.7l-7.8.1zM184 56l-4.2.1c-3.2.1-5.5.7-7.1 1.7-1.6 1.1-2.3 2.7-2.3 4.8 0 3.1 1.8 4.6 5.3 4.6 2.5 0 4.6-.7 6.1-2.2s2.3-3.4 2.3-5.8V56h-.1zM240.2 74.6h-10.9V51.2c0-2.9-.5-5.1-1.5-6.5s-2.7-2.2-4.9-2.2c-3.1 0-5.3 1-6.6 3.1-1.4 2-2 5.4-2 10.2v18.9h-10.9V34.6h8.4l1.5 5.1h.6c1.2-1.9 2.9-3.4 5-4.4s4.6-1.5 7.3-1.5c4.7 0 8.2 1.3 10.6 3.8s3.6 6.2 3.6 10.9v26.1h-.2zM274 74.6l-2.1-5.4h-.3c-1.8 2.3-3.7 3.9-5.7 4.8-1.9.9-4.5 1.3-7.6 1.3-3.8 0-6.9-1.1-9.1-3.3s-3.3-5.3-3.3-9.4c0-4.3 1.5-7.4 4.5-9.4s7.5-3.1 13.5-3.4l7-.2v-1.8c0-4.1-2.1-6.1-6.2-6.1-3.2 0-7 1-11.3 2.9l-3.6-7.4c4.6-2.4 9.7-3.6 15.3-3.6 5.4 0 9.5 1.2 12.4 3.5s4.3 5.9 4.3 10.7v26.7l-7.8.1zM270.7 56l-4.2.1c-3.2.1-5.5.7-7.1 1.7-1.6 1.1-2.3 2.7-2.3 4.8 0 3.1 1.8 4.6 5.3 4.6 2.5 0 4.6-.7 6.1-2.2s2.3-3.4 2.3-5.8l-.1-3.2zM300.9 74.6H290V18.8h10.9v55.8zM326.6 66.8c1.9 0 4.2-.4 6.9-1.3v8.1c-2.7 1.2-6.1 1.8-10 1.8-4.4 0-7.6-1.1-9.6-3.3s-3-5.5-3-10V42.8h-5.2v-4.6l6-3.7 3.2-8.5h7v8.5H333v8.2h-11.2V62c0 1.6.4 2.7 1.3 3.4.9 1 2 1.4 3.5 1.4zM356.9 75.5c-6.5 0-11.5-1.8-15.1-5.3-3.6-3.6-5.5-8.6-5.5-15.1 0-6.7 1.7-11.9 5-15.6 3.4-3.7 8-5.5 13.9-5.5 5.7 0 10.1 1.6 13.2 4.8 3.2 3.2 4.7 7.7 4.7 13.4v5.3h-25.9c.1 3.1 1 5.5 2.8 7.3 1.7 1.7 4.1 2.6 7.2 2.6 2.4 0 4.7-.3 6.8-.8 2.2-.5 4.4-1.3 6.7-2.4v8.5c-1.9 1-4 1.7-6.1 2.1-2 .5-4.6.7-7.7.7zm-1.6-33.8c-2.3 0-4.1.7-5.4 2.2s-2.1 3.6-2.3 6.3h15.3c0-2.7-.8-4.8-2.1-6.3-1.3-1.4-3.2-2.2-5.5-2.2zM396.4 75.5c-12.5 0-18.7-6.8-18.7-20.5 0-6.8 1.7-12 5.1-15.6s8.3-5.4 14.6-5.4c4.6 0 8.8.9 12.5 2.7l-3.2 8.5c-1.7-.7-3.3-1.3-4.8-1.7s-3-.7-4.4-.7c-5.7 0-8.5 4-8.5 12.1 0 7.8 2.8 11.8 8.5 11.8 2.1 0 4.1-.3 5.8-.8 1.8-.6 3.6-1.4 5.4-2.6v9.4c-1.8 1.1-3.6 1.9-5.4 2.3-1.9.3-4.2.5-6.9.5zM452.2 74.8h-10.9V51.4c0-5.8-2.2-8.7-6.5-8.7-3.1 0-5.3 1-6.6 3.1-1.4 2.1-2 5.5-2 10.1v18.9h-10.9V19h10.9v11.4c0 .9-.1 3-.3 6.2l-.3 3.2h.6c2.4-3.9 6.3-5.9 11.6-5.9 4.7 0 8.3 1.3 10.7 3.8s3.7 6.2 3.7 10.9v26.2z"
  })), _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    className: "ct_svg__st1",
    fill: "#2BA9E0",
    cx: 48,
    cy: 48,
    r: 48
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    className: "ct_svg__st2",
    fill: "#FFF",
    d: "M76.1 28.1H19.9v39.8h46.3V38.1h9.9z"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    className: "ct_svg__st0",
    fill: "#222",
    d: "M29.8 38.1h26.4v29.8l-9.9-10H29.8z"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgCt);

/***/ }),

/***/ 6141:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(9622);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sb": function() { return /* binding */ PageViewGTM; },
/* harmony export */   "wL": function() { return /* binding */ SendEventGTMWithSingleString; }
/* harmony export */ });
/* unused harmony export SendEventGTM */
/* eslint-disable import/prefer-default-export */ /* eslint-disable @typescript-eslint/ban-ts-comment */ /* eslint-disable no-unused-expressions */ var PageViewGTM = function(url) {
    var pageEvent = {
        event: "pageview",
        page: url
    };
    window && window.dataLayer && window.dataLayer.push(pageEvent);
    return pageEvent;
};
var SendEventGTM = function(action, category, label, value) {
    var pageEvent = {
        category: category,
        action: action,
        label: label,
        value: value
    };
    window && window.dataLayer && window.dataLayer.push({
        event: "event",
        pageEvent: pageEvent
    });
    return pageEvent;
};
var SendEventGTMWithSingleString = function(value) {
    window && window.dataLayer && window.dataLayer.push({
        event: value
    });
};


/***/ }),

/***/ 9622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Custom404; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _images_ct_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4812);
/* harmony import */ var _components_Layout_Banner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2467);
/* harmony import */ var _components_Layout_GlobalContainer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7970);
/* harmony import */ var _components_Layout_ErrorPage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(187);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7294);
/* harmony import */ var _lib_gtm__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9084);







function Custom404() {
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        (0,_lib_gtm__WEBPACK_IMPORTED_MODULE_6__/* .SendEventGTMWithSingleString */ .wL)("page not found");
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout_GlobalContainer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        whiteBg: true,
        center: true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Banner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "[&_svg]:h-full [&_svg]:w-[60vw] phone:[&_svg]:max-h-[100px]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_images_ct_svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_ErrorPage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                statusCode: "404"
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(6141); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);